import axiosClient from "./axiosClient";

export const cambiarPassword = (passwordActual, passwordNueva, confirmarPasswordNueva) =>
  axiosClient
    .post("/perfil/cambiar-password", { passwordActual, passwordNueva, confirmarPasswordNueva })
    .then((r) => r.data);

export const refrescarToken = () => axiosClient.post("/perfil/refrescar-token").then((r) => r.data);
